import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { axios } from 'services/axios';
import { storeName } from 'store/models/user.model';
import { RootState } from 'store/store';
import { UserType } from 'types/user.type';
import { authorize, getToken, redirectUri, refreshToken, responseType } from 'services/auth';
import { toParams, getRedirectUrl, getRefreshToken } from '../utils';

const responseTypeLocationKeys = {
  code: 'search',
  token: 'hash',
};

const responseTypeDataKeys = {
  code: 'code',
  token: 'access_token',
};

type Props = { requiredAuth?: boolean };

const useAuth = (props?: Props): { user: UserType } => {
  const { requiredAuth = true } = props || {};

  const history = useHistory();

  const user = useSelector((state: RootState) => state[storeName].user);
  const dispatch = useDispatch()[storeName];

  const getUser = () => {
    dispatch
      .getUserDetailAsync()
      .then((userResult: any) => {
        if (!userResult && requiredAuth) {
          authorize();
        } else {
          const redirectUrl = getRedirectUrl();
          if (redirectUrl) {
            const url = new URL(redirectUrl);
            history.push(`${url.pathname}${url.search}`);
          }
        }
      })
      .catch((err) => {
        console.error('useAuth:', err);
        const refresh = getRefreshToken();
        if (!refresh) {
          if (requiredAuth) {
            authorize();
          }
        } else {
          refreshToken({ onSuccess: getUser });
        }
      });
  };

  useEffect(() => {
    if (!user) {
      if (window.location.href.indexOf(redirectUri) !== -1) {
        const locationKey = responseTypeLocationKeys[responseType];
        const search = window.location[locationKey];
        const params = toParams(search);
        const responseKey = responseTypeDataKeys[responseType];
        getToken({ code: params[responseKey], onSuccess: getUser });
        return;
      }
      axios.setToken();
      getUser();
    }
  }, [user]);
  return { user };
};

export default useAuth;
